export const ROLE_LABELS = Object.freeze({
  farmers: 'Farmer',
  consumers: 'Citizen / Consumer',
  collectors: 'Collector',
  cooperatives: 'Cooperative',
  private_sector: 'Private Sector',
  processors: 'Processor',
  retailers: 'Retailer',
  traders: 'Trader',
  policy_and_regulatory_bodies: 'Policy / Regulatory Body',
  associations_and_federations: 'Association / Federation',
  extension_agents: 'Extension Agent / Farm Advisor',
  researcher: 'Researcher',
});

export function getRoleDisplayName(roleSlug, fallback = '') {
  return ROLE_LABELS[roleSlug] || fallback || roleSlug || '';
}
